import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { ordersRoutingModule } from './orders-routing.module';
import { ImportsPrimeModule } from 'src/app/_material/primeng.module';
import { SharedComponentsModule } from '../../shared/shared-components/shared-components.module';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { ordersComponent } from '../components/orders/orders.component';
import { AddordersComponent } from '../components/add-orders/add-orders.component';
import { CreateTmsOrderComponent } from '../components/tms-order/create-tms-order/create-tms-order.component';
import { ViewTmsOrderComponent } from '../components/tms-order/view-tms-order/view-tms-order.component';
import { ClickOutsideModule } from "ng-click-outside";
import { ViewBiddingComponent } from '../components/view-bidding/view-bidding.component';
import { TripOrderComponent } from '../components/trip-order/trip-order.component';
import { EndTripComponent } from '../components/end-trip/end-trip.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { VendorBillPopupComponent } from '../components/vendor-bill-popup/vendor-bill-popup.component';
import { ConfirmationService } from 'primeng/api';
import { CustomerBillPopupComponent } from '../components/customer-bill-popup/customer-bill-popup.component';


@NgModule({
  declarations: [
    ordersComponent,
    AddordersComponent,
    CreateTmsOrderComponent,
    ViewTmsOrderComponent,
    ViewBiddingComponent,
    TripOrderComponent,
    EndTripComponent,
    VendorBillPopupComponent,
    CustomerBillPopupComponent
  ],
  imports: [
    CommonModule,
    ordersRoutingModule,
    FormsModule,
    ImportsPrimeModule,
    DatePipe,
    SharedModule,
    SharedComponentsModule,
    ClickOutsideModule,
    OverlayPanelModule
],
providers: [ConfirmationService],
})
export class ordersModule { }
